// support IE >= 9
window.__IS_SHARE_PAGE__ = window.location.pathname.startsWith('/share/detail');
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
